module.exports = __webpack_public_path__ + "static/media/edit.15a96a86.svg";